import welcome from '@/assets/loyalty_welcome.png';
import tick from '@/assets/green_tick.png';
import Image from 'next/image';
import { useState } from 'react';
import LoyaltyForm from './LoyaltyForm';
import AppStorage from '@/utils/helpers';

interface Props {
  fetchLoyaltyUser: (telephone: string) => void;
}

function Welcome({ fetchLoyaltyUser }: Props) {
  const [showForm, setShowForm] = useState<boolean>(false);
  const inForm = AppStorage.get('inForm');
  const handleOPenForm = () => {
    //  router.push('/loyalty/form');
    setShowForm(true);
    AppStorage.save('inForm', true);
  };
  return (
    <div className="w-full h-screen p-5 flex flex-col justify-between">
      {/* {showAuth && (
        <div className="w-full min-h-screen p-4 bg-black bg-opacity-30 justify-center items-center ">
          <PersonalInformation />
        </div>
      )} */}

      {showForm || inForm ? (
        <LoyaltyForm fetchLoyaltyUser={fetchLoyaltyUser} />
      ) : (
        <div className='flex flex-col justify-between gap-16'>
          <div className="flex flex-col gap-16">
            <div className="flex justify-center items-center">
              <Image src={welcome} alt="Welcome" />
            </div>
            <div className="w-full flex flex-col sm:justify-center items-center gap-8 sm:gap-16">
              <div className="flex flex-col gap-2">
                <h1 className="font-semibold text-xl">
                  Welcome to the Customer Loyalty Program! 🎉
                </h1>
                <p className="text-sm font-medium text-[#475569]">
                  Earn rewards every time you order your favorite meals! Here’s
                  how it works:
                </p>
              </div>

              <div className="flex flex-col gap-4 sm:gap-10">
                <div className="flex gap-2 items-center">
                  <Image src={tick} alt="Tick" width={20} />
                  <p className="font-medium text-sm text-[#475569]">
                    <span className="font-bold">Earn Points</span> – Get points
                    on every order made through the app or in a physical store.
                  </p>
                </div>

                <div className="flex gap-2 items-center">
                  <Image src={tick} alt="Tick" width={20} />
                  <p className="font-medium text-sm text-[#475569]">
                    <span className="font-bold">Unlock Rewards</span> – Redeem
                    points for discounts, free meals, and exclusive deals.
                  </p>
                </div>

                <div className="flex gap-2 items-center">
                  <Image src={tick} alt="Tick" width={20} />
                  <p className="font-medium text-sm text-[#475569]">
                    <span className="font-bold">Get VIP Perks</span> – Enjoy
                    special offers, birthday treats, and priority access to new
                    menu items.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="w-full sm:flex items-center justify-center"
            onClick={handleOPenForm}
          >
            <button className="w-full sm:w-1/2 px-6 py-4 bg-crunchies-red rounded-lg text-center text-white cursor-pointer">
              Get Started
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Welcome;
